export function timeFix() {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, true);
  event.eventType = 'message';
  window.dispatchEvent(event);
}

export function handleScrollHeader(callback) {
  let timer = 0;

  let beforeScrollTop = window.pageYOffset;
  callback = callback || function () { };
  window.addEventListener(
    'scroll',
    () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        let direction = 'up';
        const afterScrollTop = window.pageYOffset;
        const delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) {
          return false;
        }
        direction = delta > 0 ? 'down' : 'up';
        callback(direction);
        beforeScrollTop = afterScrollTop;
      }, 50);
    },
    false
  );
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return;
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id));
  }, timeout);
}

let uuidTime = Date.now();
export function uuid() {
  // eslint-disable-next-line no-plusplus
  uuidTime++;
  return `uuid_${uuidTime}`;
}

export function fileSizeValid(rule, value, callback) {
  if (!value[0]) {
    const message = '请上传文件';
    callback(message);
  } else if (value[0].size / 1024 / 1024 > 100) {
    const message = '文件上传大小不得大于100M';
    callback(message);
  } else {
    callback();
  }
}

export function cartesianProductOf() {
  return Array.prototype.reduce.call(
    arguments,
    (a, b) => {
      const ret = [];
      a.forEach((a) => {
        b.forEach((b) => {
          ret.push(a.concat([b]));
        });
      });
      return ret;
    },
    [[]]
  );
}

export function checkImgWidth(file, width = 750, showInfo) {
  if (!file) return false;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = (error) => reject(error);
  }).then((data) => {
    const image = new Image();
    image.src = data;
    return {
      data, image,
    };
  })
    .then((res) => {
      if (showInfo) {
        return {
          data: res.data,
          width: res.image.width,
          height: res.image.height,
        };
      }
      return res.image.width === width;
    });
}
